import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { AttendanceCorrectionSalary } from "@/types/application/AttendanceCorrectionSalary";
// localStorageにattendanceCorrectionが格納されているか確認
const ls = localStorage.getItem("vuex");
const localStorageAttendanceCorrection =
  ls !== null ? JSON.parse(ls).attendanceCorrection : undefined;

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "attendanceCorrection",
  preserveState: localStorageAttendanceCorrection !== undefined
})
class AttendanceCorrectionModule extends VuexModule {
  salaryList: AttendanceCorrectionSalary[] = [];

  get getSalary() {
    return (id: number) => {
      return this.salaryList.find(salary => salary.applicationId === id);
    };
  }

  @Mutation
  private SET_SALARY(salary: AttendanceCorrectionSalary) {
    // すでに同じapplicationIdで登録されていたら一旦削除
    this.salaryList = this.salaryList.filter(
      salary => salary.applicationId !== salary.applicationId
    );
    this.salaryList.push(salary);
  }

  @Mutation
  private CLEAR_SALARY(id: number) {
    this.salaryList = this.salaryList.filter(
      salary => salary.applicationId !== id
    );
  }

  @Action
  setSalary(salary: AttendanceCorrectionSalary) {
    this.SET_SALARY(salary);
  }

  @Action
  clearSalary(id: number) {
    this.CLEAR_SALARY(id);
  }
}

export const attendanceCorrectionStore = getModule(AttendanceCorrectionModule);
